import React from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
import { useHistory } from "react-router-dom";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import Jello from "react-reveal/Jello";
import axios from "axios";

function AggiungiParcheggio() {
  let history = useHistory();

  const initialValues = {
    nome_parcheggio: "",
    luogo: "",
    orario_apertura: "",
    orario_chiusura: "",
  };

  const onSubmit = (data) => {
    axios
      .post(
        "https://website-8bit-motors.herokuapp.com/parcheggi/aggiungiParcheggio",
        data
      )
      .then((response) => {
        if (response.data.error) {
          alert(response.data.error);
        } else {
          history.push(
            "/amministratore/aggiungiParcheggio/registrazioneCheckParcheggio"
          );
        }
      });
  };

  const validationSchema = Yup.object().shape({
    nome_parcheggio: Yup.string()
      .min(3, "Valore non valido: Troppo corto!")
      .max(15, "Valore non valido: Troppo lungo!")
      .required("Per continuare devi compilare questo campo!"),
    luogo: Yup.string()
      .min(3, "Valore non valido: Troppo corto!")
      .required("Per continuare devi compilare questo campo!"),
    orario_apertura: Yup.string().required(
      "Per continuare devi compilare questo campo!"
    ),
    orario_chiusura: Yup.string().required(
      "Per continuare devi compilare questo campo!"
    ),
  });

  return (
    <Container fluid className="app">
      <Jello>
        {/* SEZIONE BANNER */}
        <Container
          fluid
          className="head-banner text-white text-center"
          id="banner_accesso"
        >
          <Row>
            <Col>
              <h1>
                <strong>8-Bit Motors</strong>
              </h1>
            </Col>
          </Row>
        </Container>
      </Jello>

      {/* FORM REGISTRAZIONE */}
      <Container className="form_registrazione">
        <h2 align="center" className="mb-3">
          <strong>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              fill="currentColor"
              className="bi bi-person-lines-fill"
              viewBox="0 0 16 16"
            >
              <path d="M6 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm-5 6s-1 0-1-1 1-4 6-4 6 3 6 4-1 1-1 1H1zM11 3.5a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5zm.5 2.5a.5.5 0 0 0 0 1h4a.5.5 0 0 0 0-1h-4zm2 3a.5.5 0 0 0 0 1h2a.5.5 0 0 0 0-1h-2zm0 3a.5.5 0 0 0 0 1h2a.5.5 0 0 0 0-1h-2z" />
            </svg>{" "}
            Aggiungi Impiegato
          </strong>
        </h2>
        <h2 className="mt-3">Dati Anagrafici</h2>
        <Formik
          onSubmit={onSubmit}
          initialValues={initialValues}
          validationSchema={validationSchema}
        >
          <Form>
            <Row className="justify-content-md-center mt-3">
              <Col>
                <label
                  className="mb-1 form_registrazione"
                  for="nome_parcheggio"
                >
                  Nome Parcheggio
                </label>
                <ErrorMessage name="nome_parcheggio" component="h6" />
                <Field
                  className="form-control input_registrazione"
                  name="nome_parcheggio"
                  placeholder="Inserisci Nome"
                />
                <label className="mb-1 mt-3 form_registrazione" for="luogo">
                  Luogo
                </label>
                <ErrorMessage name="luogo" component="h6" />
                <Field
                  type="text"
                  className="form-control input_registrazione"
                  name="luogo"
                  placeholder="Inserisci Luogo"
                />
              </Col>
              <Col>
                <label className="mb-1 form_registrazione">
                  Orario Apertura
                </label>
                <ErrorMessage name="orario_apertura" component="h6" />
                <Field
                  type="time"
                  className="form-control input_registrazione"
                  name="orario_apertura"
                  placeholder="Orario Apertura"
                />
                <label className="mb-1 mt-3 form_registrazione">
                  Orario Chiusura
                </label>
                <ErrorMessage name="orario_chiusura" component="h6" />
                <Field
                  type="time"
                  className="form-control input_registrazione"
                  name="orario_chiusura"
                  placeholder="Orario Chiusura"
                />
              </Col>
            </Row>

            {/* CONFERMA */}
            <Button variant="success" className="mt-3" type="submit">
              Conferma
            </Button>
          </Form>
        </Formik>
      </Container>
    </Container>
  );
}

export default AggiungiParcheggio;
